import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProgressBar } from 'react-bootstrap';
import { steps } from '../../containers/RequestBuilder/utils';
import { ReactComponent as Check } from '../../../../assets/icons/check.svg';
import styles from './styles.module.scss';

interface IProps {
  activeNumber: number;
}

const ProgressLine: FunctionComponent<IProps> = ({ activeNumber }) => {
  const isPassed = (number: number) => number < activeNumber;
  const getAdditionalClassName = (number: number) => (
    (number === activeNumber || isPassed(number)) ? styles.progressActive : null
  );
  const calcProgress = () => (100 / (steps.length - 1)) * (activeNumber - 1);

  return (
    <div className={styles.progressContainer}>
      <ProgressBar className={styles.progress} now={calcProgress()} />
      {
        steps.map((page, index) => (
          <div key={page} className={`${styles.progressLine} ${index + 1 === activeNumber ? styles.active : ''}`}>
            <div className={`${styles.progressLineItem} ${getAdditionalClassName(index + 1)}`}>
              {isPassed(index + 1) ? <Check /> : index + 1}
            </div>
            <span className={styles.label}><FormattedMessage id={`card.${page}.title`} defaultMessage={page} /></span>
          </div>
        ))
      }
    </div>
  );
};

export default ProgressLine;
